import { createI18n } from "vue-i18n";

import cn from './cn.json'
import en from './en.json'
import id from './id.json'
import jp from './jp.json'
import kr from './kr.json'
import vn from './vn.json'
import zh_tw from './zh_tw.json'
import utils from "@/utils/utils";

import { Locale } from 'vant';
import zhCN from 'vant/es/locale/lang/zh-CN';
import enUS from 'vant/es/locale/lang/en-US';
import jaJP from 'vant/es/locale/lang/ja-JP';
import koKR from 'vant/es/locale/lang/ko-KR';
import viVN from 'vant/es/locale/lang/vi-VN';
import idID from 'vant/es/locale/lang/id-ID';
import zhTW from 'vant/es/locale/lang/zh-TW';

const vantLanguageList = [
  { alias: 'cn', text: "zh-CN", value: zhCN },
  { alias: 'en', text: "en-US", value: enUS },
  { alias: 'jp', text: "ja-JP", value: jaJP },
  { alias: 'kr', text: "ko-KR", value: koKR },
  { alias: 'vn', text: "vi-VN", value: viVN },
  { alias: 'id', text: "id-ID", value: idID },
  { alias: 'zh-tw', text: "zh-TW", value: zhTW },
]

const messages = {
  'cn': cn,
  'en': en,
  'id': id,
  'jp': jp,
  'kr': kr,
  'vn': vn,
  'zh-tw': zh_tw
}

const i18n = createI18n({
  locale: utils.getloc('locale') || 'cn', // 设置当前语言
  fallbackLocale: 'cn', // 设置回退语言
  globalInjection: true, // 全局注册 $t 方法
  messages
})

// vant 国际化处理
const currentLang = vantLanguageList.find(lang => lang.alias === i18n.global.locale);
if(currentLang) {
  Locale.use(currentLang.text, currentLang.value)
} else {
  // 如果没有找到对应的语言，使用默认语言
  Locale.use('zh-TW', zhTW)
}

export default i18n